import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  HostBinding,
} from '@angular/core';
import { MenuService } from '@core';
import screenfull from 'screenfull';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @HostBinding('class') class = 'matero-header';

  @Input() showBranding = false;

  @Input() showToggle = true;

  @Output() toggleSidenav = new EventEmitter();

  @Output() toggleSidenavNotice = new EventEmitter();

  menus = this.menuService.getFilteredMenu();

  constructor(private menuService: MenuService) {}

  toggleFullscreen() {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }

  get isFullScreen() {
    return screenfull.isFullscreen;
  }
}
